import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionFreebieWidget = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    params: {
        cartId: string;
        originalCartId: string;
        itemId: string;
        freebieUnlocked: string;
        itemType: string;
    },
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_FREEBIE_WIDGET,
        extraParams: JSON.stringify({
            cartId: params.cartId,
            originalCartId: params.originalCartId,
            itemId: params.itemId,
            freebieUnlocked: params.freebieUnlocked,
            itemType: params.itemType,
        }),
    });
};

export const clickFreebieClaimButtonEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    itemId: string,
    itemType: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_FREEBIE_CLAIM_BUTTON,
        extraParams: JSON.stringify({ itemId: itemId, itemType: itemType }),
    });
};
